export default __webpack_public_path__ + "static/media/pigybank-old.f4d5dfda.png";